import { render } from "./SettingsRoadmap.vue?vue&type=template&id=5a246cd4&scoped=true"
import script from "./SettingsRoadmap.vue?vue&type=script&lang=js"
export * from "./SettingsRoadmap.vue?vue&type=script&lang=js"

import "./SettingsRoadmap.vue?vue&type=style&index=0&id=5a246cd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a246cd4"]])

export default __exports__